import {FollowupQuestion, Question} from "../../CaseDataInterfaces";
import React, {FC} from "react";
import "./QuestionButton.css";
import tail from './tail.svg';

interface QuestionButtonProps {
    model: Question|FollowupQuestion;
    main: boolean;
    onClick: () => void;
}

const QuestionButton: FC<QuestionButtonProps> = ({model, main, onClick}) => {
    return (
        <button
            className={'question-button' + (main ? '' : ' question-button-followup')}
            onClick={() => (onClick())}>
            {model.text}
            {
                main ?
                    <img src={tail} className="question-button-tail" alt="" />
                    :
                    undefined
            }

        </button>
    )
}

export default QuestionButton;